module.exports = __webpack_public_path__ + "img/menu_icon.0043eac3.svg";